import { ApplicationConfig, enableProdMode, inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withRouterConfig, withViewTransitions } from '@angular/router';
import { appRoutes } from './app.routes';

import { environment } from '../environments/environment';
import {
    provideSharedConfig,
    provideI18nConfig,
    provideJwtConfig,
    provideMomentConfig,
    provideMaterialConfig,
} from './config';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
    HttpResponse,
    provideHttpClient,
    withFetch,
    withInterceptors,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { OtpVerificationComponent } from './shared/otp-verification/otp-verification';
import { connectedFseUserId } from './utils';

if (environment.production) {
    enableProdMode();
}

function clientHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    if (req.url?.startsWith('/fse/')) {
        req = req.clone({
            headers: req.headers.set('Client-ID', connectedFseUserId()),
        });
    }
    return next(req);
}
function fseMessageInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const dialog = inject(MatDialog);
    return next(req).pipe(
        tap({
            next: (event: HttpEvent<unknown>) => {
                if (req.url?.startsWith('/fse/') && event instanceof HttpResponse) {
                    if (event.body && (event.body as any).code === 'OTP_REQUIRED') {
                        const isOtpOpen = dialog.openDialogs.some(d => d.componentInstance instanceof OtpVerificationComponent);
                        if (!isOtpOpen) {
                            dialog.open(OtpVerificationComponent);
                        }
                    }
                }
            },
            error: (error: HttpErrorResponse) => {
                if (req.url?.startsWith('/fse/')) {
                    console.log(error);
                }
            }
        })
    );
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(withInterceptorsFromDi(), withFetch(), withInterceptors([clientHeaderInterceptor, fseMessageInterceptor])),
        provideI18nConfig(),
        provideJwtConfig(),
        provideSharedConfig(),
        provideMomentConfig(),
        provideMaterialConfig(),
        provideRouter(appRoutes, withViewTransitions(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
        provideAnimationsAsync(),
    ],
};
